/* eslint-disable react-hooks/exhaustive-deps */
import { useThree } from '@react-three/fiber';
import { useEffect } from 'react';
const disposeMaterial = (material) => {
    // Dispose textures
    for (const key in material) {
        const value = material[key];
        if (value && value.isTexture) {
            value.dispose();
        }
    }
    material.dispose();
};
const disposeScene = (scene) => {
    scene.traverse((m) => {
        // Dispose geometries
        const mesh = m;
        if (mesh.geometry) {
            mesh.geometry.dispose();
        }
        // Dispose materials and associated textures
        if (mesh.material) {
            // Handle multi-materials
            if (Array.isArray(mesh.material)) {
                mesh.material.forEach(disposeMaterial);
            }
            else {
                disposeMaterial(mesh.material);
            }
        }
    });
    // Remove all children
    while (scene.children.length > 0) {
        scene.remove(scene.children[0]);
    }
};
const CanvasCleanupOnUnmount = () => {
    const { gl, scene } = useThree();
    useEffect(() => {
        return () => {
            disposeScene(scene);
            gl.forceContextLoss?.();
            gl.dispose?.();
        };
    }, []);
    return null;
};
export default CanvasCleanupOnUnmount;
